import { useReducer, createContext, useContext } from 'react';
import Constants from '../../constants';
import reducer from './profile-reducer';

const ProfileContext = createContext();
const initialState = {
  userType: Constants.USER_TYPE_ALPHA,
};
const ProfileProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <ProfileContext.Provider value={{ ...state }}>
      {children}
    </ProfileContext.Provider>
  );
};

const useProfileContext = () => {
  return useContext(ProfileContext);
};

export { ProfileProvider, useProfileContext };
